<template>
  <article>
    <header class="title-bar zz-title-bar">
      <h2>选择品牌</h2>
    </header>
    <ul class="car-list">
      <li v-for="brand in brands" :key="brand.id" @click.stop="selSeries(brand.id)">
        <a href="javascript:void(0);">
          <img :src="brand.icon" alt="" width="35" height="35" class="">
          <span>{{brand.name}}</span>
        </a>
      </li>
    </ul>
  </article>
</template>
<script>
import cache from '../../../common/cache'

export default {
  data () {
    return {
      sessionKey: 'intendBrands',
      brands: []
    }
  },
  created () {
    this.$rest.saleManage.intendBrands({ mode: 'compatibility' }).then((res) => {
      if (res.code === 0) {
        this.brands = res.data
        cache.setSessionData(this.sessionKey, this.brands)
      } else {
        this.showToast(res.message)
      }
    })
  },
  methods: {
    selSeries (brandId) {
      this.$router.push({
        path: '/salemanage/car/series/' + brandId
      })
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
  .car-tip-title {
    line-height: 22px;
    color: #666;
    padding-left: 10px;
    margin-top: 15px;
  }

  .car-style-add {
    padding: 0 0 30px 0;
    margin-top: -14px;
    input {
      background: #fff;
      padding: 10px;
      box-sizing: border-box;
    }
    .plr {
      padding: 0 30px;
    }
    .btn {
      border-radius: 0;
      height: 44px;
      line-height: 44px;
      font-size: 15px;
    }
    .weui_cell {
      padding: 15px 10px;
    }
  }

  @import "../../../stylesheets/modules/manage/input.less";
</style>
